import { Api } from 'helpers/ApiClient';
import { buildFormData } from 'helpers/Form';

export class Account {
  static async show(id) {
    try {
      const response = await Api.client.get(`/api/v1/accounts/${id}.json`);
      return {
        account: response.data.account,
        user: response.data.user,
      };
    } catch (e) {
      if (e.response && e.response.status !== 500) {
        return {
          status: e.response.status,
          error: e.response.data,
        };
      }
      return {
        error: 'Unknown error showAccount',
        status: 500,
      };
    }
  }

  static async update(id, param) {
    try {
      const response = await Api.client.put(
        `/api/v1/accounts/${id}.json`,
        buildFormData(param, 'account'),
      );
      return response.data;
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error updateAccount',
        textError: e.response.data,
      };
    }
  }

  static async delete(param) {
    try {
      const response = await Api.client.delete('/api/v1/accounts/' + param);
      return response.data;
    } catch (e) {
      console.error('error', e.message);
      return {
        error: 'Unknown error updateAccount',
        textError: e.response.data,
      };
    }
  }

  static async updatePayment(body) {
    try {
      const response = await Api.client.put(
        '/api/v1/account/update_payment',
        body,
      );
      return {
        data: response.data.user,
        status: response.status,
      };
    } catch (e) {
      let error = '';
      switch (e.response.status) {
        case 422:
          error = e.response.data;
          break;
        default:
          error = 'Service temporary unavailable!';
      }

      return {
        status: e.response.status,
        error,
      };
    }
  }

  static async updateBillingPeriod(body) {
    try {
      const response = await Api.client.put(
        '/api/v1/account/update_next_subscription_plan.json',
        body,
      );
      return {
        data: response.data.user,
        status: response.status,
      };
    } catch (e) {
      console.error('updateAccount error', e.message);
      return {
        error: 'Unknown error updateAccount',
        textError: e.response.data,
      };
    }
  }

  static async updatePaymentAndSubscribe(body) {
    try {
      const response = await Api.client.put(
        '/api/v1/account/update_payment_and_subscribe',
        body,
      );
      return {
        data: response.data.user,
        status: response.status,
      };
    } catch (e) {
      let error = '';
      switch (e.response.status) {
        case 422:
          error = e.response.data;
          break;
        default:
          error = 'Service temporary unavailable!';
      }
      return {
        status: e.response.status,
        error,
      };
    }
  }

  static async updateTrialAndSubscribe(body) {
    try {
      const response = await Api.client.post(
        '/api/v1/user/upgrade_from_trial_to_pro',
        body,
      );
      return {
        data: response.data.user,
        status: response.status,
      };
    } catch (e) {
      let error = '';
      switch (e.response.status) {
        case 422:
          error = e.response.data;
          break;
        default:
          error = 'Service temporary unavailable!';
      }
      return {
        status: e.response.status,
        error,
      };
    }
  }

  static async createSubscription() {
    try {
      const response = await Api.client.post('/api/v1/subscriptions.json');
      return {
        data: response.data.user,
        status: response.status,
      };
    } catch (e) {
      console.error('createSubscription request error: ', e.message);
      return {
        error: 'Unknown error createSubscription',
        textError: e.response.data,
      };
    }
  }

  static async enableRenew() {
    try {
      const response = await Api.client.put(
        '/api/v1/subscriptions/enable.json',
      );
      return {
        data: response.data.user,
        status: response.status,
      };
    } catch (e) {
      console.error('enableRenew request error: ', e.message);
      return {
        error: 'Unknown error enableRenew',
        textError: e.response.data,
      };
    }
  }

  static async disableRenew() {
    try {
      const response = await Api.client.put(
        '/api/v1/subscriptions/disable.json',
      );
      return {
        data: response.data.user,
        status: response.status,
      };
    } catch (e) {
      console.error('disableRenew request error: ', e.message);
      return {
        error: 'Unknown error disableRenew',
        textError: e.response.data,
      };
    }
  }
}

export class Accounts {
  static async show() {
    try {
      const response = await Api.client.get('/api/v1/accounts.json');
      return {
        accounts: response.data,
      };
    } catch (e) {
      if (e.response && e.response.status !== 500) {
        return {
          status: e.response.status,
          error: e.response.data,
        };
      }
      return {
        error: 'Unknown error showAccounts',
        status: 500,
      };
    }
  }

  static async create(body) {
    try {
      const response = await Api.client.post('/api/v1/accounts.json', body);
      return {
        data: response.data,
        status: response.status,
      };
    } catch (e) {
      if (e.response && e.response.status !== 500) {
        return {
          status: e.response.status,
          error: e.response.data,
        };
      }
      return {
        error: 'Unknown error createAccounts',
        status: 500,
      };
    }
  }
}

export class Shortcode {
  static async check(code) {
    try {
      const response = await Api.client.get(
        `/api/v1/check_shortcode_status/${code}`,
      );
      return {
        data: response.data,
        status: response.status,
      };
    } catch (e) {
      if (e.response && e.response.status !== 500) {
        return {
          status: e.response.status,
          error: e.response.data,
        };
      }
      return {
        error: 'Unknown error short code check',
        status: 500,
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/content/api.js